module.exports = __webpack_public_path__ + "static/img/children5.dbc77907.jpg";